import React from "react";


export default function RedirectToAppDownload() {
    window.location = 'http://onelink.to/5jec38';

    return null;
}